module.exports = __webpack_public_path__ + "img/canvas.b5dd4d4.svg";